/**
 * Décision du relecteur sur le co-titulaire acheteur (SKIP-454), lue dans
 * `validatedFields` du payload de review : le serveur l'y range sous
 * COTITULAIRE_DECISION_KEY quand la review envoie `cotitulaire_present`.
 * null = pas de décision : on suit ce que l'OCR / la base ont dérivé.
 */
export const COTITULAIRE_DECISION_KEY = '__cotitulaire_present';

type ValidatedFields = Record<string, { value?: unknown; validated_at?: string } | undefined> | null | undefined;

export const readCotitulaireDecision = (validatedFields: ValidatedFields): boolean | null => {
  const raw = validatedFields?.[COTITULAIRE_DECISION_KEY]?.value;
  if (raw === true || raw === 'true') return true;
  if (raw === false || raw === 'false') return false;
  return null;
};

export const effectiveCotitulaireAcheteur = (decision: boolean | null, derived: boolean): boolean =>
  decision ?? derived;

/** Le groupe de champs « Co-titulaire » s'affiche-t-il ? */
export const showCotitulaireGroup = (decision: boolean | null, groupHasData: boolean): boolean => {
  if (decision === false) return false;
  if (decision === true) return true;
  return groupHasData;
};
